import {gql} from '@apollo/client'

import {TFA_ENROLLMENT_FRAGMENT, TFA_CONFIG_FRAGMENT} from '../fragments/tfa'

export const TFA_CONFIG = gql`
  ${TFA_CONFIG_FRAGMENT}
  query tfaConfig {
    tfaConfig {...TfaConfigFragment}
  }
`

export const TFA_ENROLLMENTS = gql`
  ${TFA_ENROLLMENT_FRAGMENT}
  query tfaEnrollments {
    tfaEnrollments {...TfaEnrollmentFragment}
  }
`

export const BACKUP_CODES = gql`
  query backupCodes {
    backupCodes {
      id
      tfaConfigId
      createdAt
      updatedAt
    }
  }
`
